<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex xs8 offset-xs2>
        <v-card>
          <v-data-table :headers="headers" :items="fabricCategories">
            <template slot="items" slot-scope="props">
              <td>{{ props.item.name }}</td>
              <td>
                <router-link v-bind:to="{ name: 'Prices', params: { fabricCategoryID: props.item._id }}">Pricing</router-link>
                <button @click="deleteFabricCategory(props.item._id)">Delete</button>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import FabricCategoryService from '@/services/FabricCategoryService.js'
export default {
  data () {
    return {
      fabricCategories: [],
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Actions', value: 'actions' }
      ]
    }
  },
  mounted () {
    this.getFabricCategories()
  },
  methods: {
    async getFabricCategories () {
      const response = await FabricCategoryService.getFabricCategories()
      this.fabricCategories = response.data.fabricCategories
    },

    async deleteFabricCategory (fabricCategoryID) {
      await FabricCategoryService.deleteFabricCategory(fabricCategoryID)

      this.getFabricCategories()
    }
  }
}
</script>
<style scoped>
    #fabricCategoriess {
        text-align: left;
        border-collapse: collapse;
        width: 100%;
    }

    #fabricCategoriess th {
        background: grey;
        color: white;
        padding: 5px;
    }

    #fabricCategoriess td {
        padding: 5px;
    }

    #fabricCategoriess tr:nth-child(even) td {
        background: lightgrey;
    }
</style>



// WEBPACK FOOTER //
// src/components/admin/FabricCategories.vue